import { Button } from '@synoptic/ui-kit/button/button.tsx';
import { IconButton } from '@synoptic/ui-kit/button/icon-button.tsx';
import { EditPencilIcon } from '@synoptic/ui-kit/icons/react/edit-pencil.tsx';
import { useIsMobile, useIsTablet } from '@synoptic/ui-kit/responsive/hooks.ts';
import { FC } from 'react';
import {
  editProfileButtonContainer,
  editProfileButtonContent,
} from '@/routes/_app.$username/profile-card/main-statistics/identity/edit-profile/edit-profile-button.css.ts';
import { EditProfileModal } from '@/routes/_app.$username/profile-card/main-statistics/identity/edit-profile/edit-profile-form/edit-profile-modal.tsx';

export const EditProfileButton: FC<{ backgroundImageKey?: string }> = ({
  backgroundImageKey,
}) => {
  const isTablet = useIsTablet();
  const isMobile = useIsMobile();

  return (
    <div className={editProfileButtonContainer}>
      <EditProfileModal
        backgroundImageKey={backgroundImageKey}
        trigger={
          !isMobile ? (
            <IconButton variant={'outline'} size={'small'}>
              <EditPencilIcon />
            </IconButton>
          ) : (
            <Button
              endIcon={isTablet ? <EditPencilIcon /> : null}
              variant={'outline'}
              size={'small'}
              className={editProfileButtonContent}
            >
              Edit profile
            </Button>
          )
        }
      />
    </div>
  );
};
